

cdb.admin.WizardDialog = cdb.ui.common.Dialog.extend({
});
